export interface IconProps {
  width?: number;
  height?: number;
}

export default function OutdentIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.999"
      height="14"
      viewBox="0 0 14.999 14"
    >
      <g transform="translate(-.092 .001)">
        <path
          fill="currentColor"
          d="M.5 14a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5zm2.253-4L.128 7.371a.438.438 0 010-.618l2.625-2.626a.438.438 0 01.747.31v5.25a.437.437 0 01-.441.438.427.427 0 01-.306-.125zM5.5 9.936a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5zm0-4.064a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v.751a.5.5 0 01-.5.5zM.5 1.75a.5.5 0 01-.5-.5V.5A.5.5 0 01.5 0h14a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5z"
          data-name="Union 25"
          transform="translate(.092 -.001)"
        ></path>
      </g>
    </svg>
  );
}
